var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 470.81 159.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00d5ff;\n      }\n\n      .cls-2 {\n        fill: #00a9ff;\n      }\n\n      .cls-3 {\n        fill: #0064a9;\n      }\n\n      .cls-4 {\n        fill: #042958;\n        font-family: Avenir-Black, Avenir;\n        font-size: 88.29px;\n        font-weight: 800;\n        letter-spacing: .08em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,45.63v50.66c0,34.73,28.15,62.88,62.88,62.88v-50.66c0-34.73-28.15-62.88-62.88-62.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m134.73,45.63v50.66c0,34.73-28.15,62.88-62.88,62.88v-50.66c0-34.73,28.15-62.88,62.88-62.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 71.84,
    cy: 25.14,
    r: 25.14
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(174.5 112.64)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "UTIRX")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f8933373.svg";
export { ForwardRef as ReactComponent };